import { Directive, ElementRef, HostListener, Input, inject } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Directive({ selector: '[appFirstLetterUpperCase]' })
export class FirstLetterUpperCaseDirective {
  @Input('appFirstLetterUpperCase') public model: AbstractControl | null;

  private _elementRef = inject(ElementRef);

  // input event: https://developer.mozilla.org/en-US/docs/Web/Events/input
  // https://angular.io/guide/attribute-directives
  @HostListener('input', ['$event'])
  public onInputChange(event: InputEvent): void {
    const target = event.target as HTMLInputElement;
    const caretPos = target.selectionStart;
    const text: string = target.value.trimLeft();
    let result = '';
    if (text.length > 0) {
      result = text[0].toUpperCase();
      if (text.length > 1) {
        result += text.substr(1, text.length);
      }
    }

    this.model!.setValue(result);
    this._elementRef.nativeElement.setSelectionRange(caretPos, caretPos);
  }
}
